import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["title", "titleId", "description", "hint", "isChecked", "isDisabled", "onChange", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React, { useRef } from 'react';
import styled from 'styled-components';
import useUniqueId from 'hooks/useUniqueId';
import Card from 'components/Card';
import Flex from 'components/Flex';
import Box from 'components/Box';
import Text from 'components/Text';
import Switch from 'components/Switch';
import Divider from 'components/Divider';
import Heading from 'components/Heading';
import { BASIC } from 'styles/spacingPresets';
import Hint from 'components/Hint';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Grid = styled.div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'isVisible';
  }
}).withConfig({
  displayName: "TitleCardWithSwitch__Grid",
  componentId: "sc-1gp4d1n-0"
})(["display:grid;grid-template-rows:", ";transition:grid-template-rows 0.5s ease-in-out;"], function (p) {
  return p.isVisible ? '1fr' : '0fr';
});
export function TitleCardWithSwitch(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    description = _ref.description,
    hint = _ref.hint,
    isChecked = _ref.isChecked,
    _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
    onChange = _ref.onChange,
    children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var id = useUniqueId();
  var switchRef = useRef(null);
  var descriptionId = description ? "".concat(id, "-desc") : undefined;
  var headingId = titleId !== null && titleId !== void 0 ? titleId : "".concat(id, "-heading");

  // Allow clicking the whole card to enable the switch.
  // Disabling requires clicking the switch directly.
  function handleCardClick(_ref2) {
    var target = _ref2.target;
    if (!isChecked && switchRef.current !== null && target instanceof Node && switchRef.current !== target && !switchRef.current.contains(target)) {
      switchRef.current.click();
    }
  }
  return /*#__PURE__*/_jsxs(Card, _objectSpread(_objectSpread({
    px: BASIC.LARGE,
    py: BASIC.MEDIUM,
    breakpoints: BASIC.BREAKPOINTS
  }, otherProps), {}, {
    onClick: handleCardClick,
    cursor: isChecked ? undefined : 'pointer',
    children: [/*#__PURE__*/_jsxs(Flex, {
      children: [/*#__PURE__*/_jsxs(Box, {
        grow: true,
        shrink: true,
        pr: "m",
        children: [/*#__PURE__*/_jsx(Heading, {
          as: "h2",
          id: headingId,
          children: title
        }), Boolean(description) && /*#__PURE__*/_jsx(Text, {
          id: descriptionId,
          as: "p",
          size: "s",
          mt: "xxs",
          children: description
        }), Boolean(hint) && /*#__PURE__*/_jsx(Hint, {
          mt: "xxs",
          children: hint
        })]
      }), /*#__PURE__*/_jsx(Box, {
        children: /*#__PURE__*/_jsx(Switch, {
          id: id,
          ref: switchRef,
          disabled: isDisabled,
          checked: isChecked,
          onChange: onChange,
          "aria-labelledby": headingId,
          "aria-describedby": descriptionId
        })
      })]
    }), /*#__PURE__*/_jsx(Grid, {
      "aria-hidden": !isChecked,
      isVisible: isChecked,
      children: /*#__PURE__*/_jsxs(Box, {
        overflow: "hidden",
        children: [/*#__PURE__*/_jsx(Divider, {
          my: "m"
        }), children]
      })
    })]
  }));
}